import { styled } from '@mui/material';

import { ReactNode } from 'react';

export type SimulationLabelProps = {
  challenge: string;
};

const StyledLabel = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const Data = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

const Label = styled('strong')({
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1.3,
});

const Description = styled('span')({
  fontSize: 12,
  fontWeight: 300,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  lineHeight: 1.3,
});

export type LabelProps = {
  label: string;
  description: ReactNode;
  image: ReactNode;
};

export const HeaderLabel = ({ label, description, image }: LabelProps) => {
  return (
    <StyledLabel>
      {image ? image : null}
      <Data>
        <Label>{label}</Label>
        {description ? <Description>{description}</Description> : null}
      </Data>
    </StyledLabel>
  );
};
